angular.module('bb.util').component('datePicker', {
  restrict: 'E',
  bindings: {
    selecteddate: '=?',
    unavailabledays: '=',
    unavailableafter: '=',
    openhousedays: '=',
    offerdate: '=',
    offeranytime: '<',
    updatefn: '&',
    resetDate: '<',
    datepickerTitle: '@',
    customMessage: '@',
    pickdate: '@',
    // Do you run the update function on a day in the past?
    pickPast: '=',
    mondayfirst: '@',
    originalDate: '<',
  },
  controllerAs: 'vm',
  template: require('./date_picker.html'),
  controller: DatePickerController,
});

DatePickerController.$inject = ['$rootScope', '$scope', 'UtilService'];
function DatePickerController($rootScope, $scope, UtilService) {
  const vm = this;
  vm.$onInit = function () {
    let today;
    if (!vm.selecteddate) {
      vm.selecteddate = new Date();
    }
    vm.days = [
      { long: 'Sunday', short: 'Sun' },
      { long: 'Monday', short: 'Mon' },
      { long: 'Tuesday', short: 'Tue' },
      { long: 'Wednesday', short: 'Wed' },
      { long: 'Thursday', short: 'Thu' },
      { long: 'Friday', short: 'Fri' },
      { long: 'Saturday', short: 'Sat' },
    ];
    if (vm.mondayfirst == 'true') {
      const sunday = vm.days[0];
      vm.days.shift();
      vm.days.push(sunday);
    }

    vm.monthNames = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];

    function getSelected() {
      if (vm.currentViewDate.getMonth() == vm.localdate.getMonth()) {
        if (vm.currentViewDate.getFullYear() == vm.localdate.getFullYear()) {
          for (let number in vm.month) {
            if (vm.month[number].daydate == vm.localdate.getDate()) {
              vm.month[number].selected = true;
              if (vm.mondayfirst == 'true') {
                if (parseInt(number) === 0) {
                  number = 6;
                } else {
                  number -= 1;
                }
              }
              vm.selectedDay = vm.days[vm.month[number].dayname].long;
            }
          }
        }
      }
    }

    function getDaysInMonth() {
      const month = vm.currentViewDate.getMonth();
      const date = new Date(vm.currentViewDate.getFullYear(), month, 1);
      const days = [];

      while (date.getMonth() === month) {
        let showday = true;
        if (date < today && !vm.pickPast) {
          showday = false;
        }
        let inPast = date < today;
        if (
          today.getDate() == date.getDate() &&
          today.getYear() == date.getYear() &&
          today.getMonth() == date.getMonth()
        ) {
          // reaches here is the date is the current day
          showday = true;
          inPast = false;
        }

        const day = new Date(date);
        const dayname = day.getDay();
        const daydate = day.getDate();

        days.push({ dayname, daydate, showday, inPast });
        date.setDate(date.getDate() + 1);
      }
      vm.month = days;
    }

    function initializeDate() {
      vm.currentViewDate = new Date(vm.localdate);
      vm.selecteddate = new Date(vm.localdate);
      vm.currentMonthName = function () {
        return vm.monthNames[vm.currentViewDate.getMonth()];
      };
      getDaysInMonth();
      getSelected();
    }

    // Takes selected time and date and combines them into a date object
    function getDateAndTime(localdate) {
      return new Date(
        localdate.getFullYear(),
        localdate.getMonth(),
        localdate.getDate(),
        0,
        0,
      );
    }

    // Convert to UTC to account for different time zones
    function convertToUTC(localdate) {
      const date_obj = getDateAndTime(localdate);
      const utcdate = new Date(
        date_obj.getUTCFullYear(),
        date_obj.getUTCMonth(),
        date_obj.getUTCDate(),
        date_obj.getUTCHours(),
        date_obj.getUTCMinutes(),
      );
      return utcdate;
    }

    vm.getDateStr = function (day) {
      const date = new Date(
        vm.currentViewDate.getFullYear(),
        vm.currentViewDate.getMonth(),
        day.daydate,
      );
      return moment(date).format('YYYY-MM-DD');
    };

    vm.isDayUnavailable = function (day) {
      const dateStr = vm.getDateStr(day);
      const dateAfter = vm.isDayUnavailableAfter(day);

      return (
        !vm.unavailabledays ||
        vm.unavailabledays.indexOf(dateStr) > -1 ||
        dateAfter
      );
    };

    vm.isDayUnavailableAfter = function (day) {
      if (vm.unavailableafter)
        return (
          vm.unavailableafter.getTime() <=
          new Date(
            vm.currentViewDate.getFullYear(),
            vm.currentViewDate.getMonth(),
            day.daydate,
          ).getTime()
        );
      return false;
    };

    vm.dayHasOpenHouse = function (day) {
      const dateStr = vm.getDateStr(day);
      return vm.openhousedays && vm.openhousedays.indexOf(dateStr) > -1;
    };

    vm.selectDate = function (day) {
      if (day.inPast && !vm.pickPast) return;

      if (vm.isDayUnavailableAfter(day) && vm.isAdmin()) {
        const maxDays =
          moment(vm.unavailableafter)
            .startOf('day')
            .diff(moment().startOf('day'), 'days') + 1;
        return swal(
          'SENITRILOCK APPOINTMENT',
          `You can only book appointments on this listing a maximum of ${maxDays} days from the showing date.`,
        );
      }

      if (vm.pickdate == 'true' && day.showday) {
        for (const number in vm.month) {
          const item = vm.month[number];
          if (item.selected === true) {
            item.selected = false;
          }
        }
        day.selected = true;
        vm.selectedDay = vm.days[day.dayname].long;

        vm.localdate = new Date(
          vm.currentViewDate.getFullYear(),
          vm.currentViewDate.getMonth(),
          day.daydate,
        );
        initializeDate(vm.localdate);
        vm.updateDate();
      }
    };

    vm.updateDate = function () {
      if (vm.localdate) {
        const newdate = getDateAndTime(vm.localdate);
        vm.updatefn({ newdate });
      }
    };

    vm.moveForward = function () {
      let month = vm.currentViewDate.getMonth() + 1;
      let year = vm.currentViewDate.getFullYear();
      if (month === 12) {
        year += 1;
        month = 0;
      }
      vm.currentViewDate.setFullYear(year, month, 1);
      getDaysInMonth();
      getSelected();
    };

    vm.moveBack = function () {
      vm.currentViewDate.setMonth(vm.currentViewDate.getMonth() - 1);
      if (vm.currentViewDate.getMonth() == -1) {
        vm.currentViewDate.setDate(vm.currentViewDate.getFullYear() - 1, 0, 1);
      }
      getDaysInMonth();
      getSelected();
    };

    vm.calcOffset = function (day, index) {
      if (index === 0) {
        let offset = `${day.dayname * 14.2857142}%`;
        if (vm.mondayfirst == 'true') {
          offset = `${(day.dayname - 1) * 14.2857142}%`;
        }
        return offset;
      }
    };

    vm.isOfferDate = function (day) {
      return vm.getDateStr(day) === vm.offerdate && !vm.offeranytime;
    };

    // I dont know if we need this. see app.css for the
    // rest of the code.
    // ///////////////////////////////////////////////
    // // Check size of parent element, apply class //
    // ///////////////////////////////////////////////
    // vm.checkWidth = function(apply) {
    //   var parent_width = element.parent().width();
    //   if (parent_width < 620) {
    //     vm.compact = true;
    //   } else {
    //     vm.compact = false;
    //   }
    //   if (apply) {
    //     vm.$apply();
    //   }
    // };
    // vm.checkWidth(false);

    vm.isAdmin = () => {
      return $rootScope?.auth?.isAdmin;
    };

    UtilService.getServerDate().then(data => {
      vm.localdate = vm.originalDate
        ? new Date(vm.originalDate)
        : new Date(data.date);
      today = new Date(data.date);
      vm.localdate.setMinutes(Math.round(vm.localdate.getMinutes() / 60) * 30);
      initializeDate();

      vm.$onChanges = changes => {
        if (changes.resetDate) {
          UtilService.getServerDate().then(({ date }) => {
            vm.localdate = new Date(date);
            vm.localdate.setMinutes(
              Math.round(vm.localdate.getMinutes() / 60) * 30,
            );
            initializeDate();
          });
        } else if (vm.selecteddate) {
          vm.localdate = new Date(vm.selecteddate);
          initializeDate();
        }
      };
    });
  };
}

export {};
